import { Table as TableUI } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled(TableUI.Thead)``;
